import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { useHistory, Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactHtmlParser from 'react-html-parser';

import { API_BASE_URL } from '../../config.js';
import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector.js';

import { statisticsAction, statisticsCloseAction } from '../../actions/settingsAction.js';

const Dept_ot = (props) => {
    const { fixNavbar } = props;
    const history = useHistory();

    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);

    const [selectedIds, setSelectedIds] = useState([]);

    // ------------------ FETCH DATA ------------------
    const fetchData = () => {
        axios.get(`${API_BASE_URL}/dept_overtime_list`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
        })
        .then(res => setData(res.data))
        .catch(err => console.log(err));
    };

    useEffect(() => {
        fetchData();
    }, []);

    // ------------------ FILTER + PAGINATION ------------------
    const filteredItems = data.filter(item =>
        `${item.employee_id}${item.employee_name}${item.department_name}`
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
    const indexOfLast = currentPage * entriesPerPage;
    const indexOfFirst = indexOfLast - entriesPerPage;
    const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    // ------------------ DEFAULT SELECT ALL ON PAGE LOAD ------------------
    useEffect(() => {
        if (filteredData.length > 0) {
            const defaultSelectedIds = filteredData
                .filter(row => row.floor_status === 2 && row.dept_status === 1)
                .map(row => row.overtime_id);
            setSelectedIds(defaultSelectedIds);
        } else {
            setSelectedIds([]);
        }
    }, [data, currentPage, searchTerm, entriesPerPage]);

    // ------------------ SELECT/UNSELECT ALL ------------------
    const isAllSelected = filteredData
        .filter(row => row.floor_status === 2 && row.dept_status === 1)
        .every(row => selectedIds.includes(row.overtime_id));

    const toggleSelectAll = () => {
        const currentIds = filteredData
            .filter(row => row.floor_status === 2 && row.dept_status === 1)
            .map(row => row.overtime_id);

        if (isAllSelected) {
            // Unselect all visible rows
            setSelectedIds(selectedIds.filter(id => !currentIds.includes(id)));
        } else {
            // Select all visible rows
            setSelectedIds([...new Set([...selectedIds, ...currentIds])]);
        }
    };

    // ------------------ HANDLE SINGLE CHECKBOX ------------------
    const handleCheckboxChange = (e, id) => {
        if (e.target.checked) {
            setSelectedIds([...selectedIds, id]);
        } else {
            setSelectedIds(selectedIds.filter(item => item !== id));
        }
    };

    // ------------------ SEARCH ------------------
    const handleSearch = (e) => setSearchTerm(e.target.value);
    const clearInput = () => setSearchTerm("");

    // ------------------ APPROVE SELECTED ------------------
    const approveSelected = () => {
        if (selectedIds.length === 0) {
            toast.warn("No records selected!",{position: "bottom-right"});
            return;
        }

        axios.post(`${API_BASE_URL}/dept_overtime_approve_bulk`, {
            overtime_ids: selectedIds,
            status: "Approved"
        }, {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
        })
        .then(() => {
            toast.success("Selected records approved!",{position: "bottom-right"});
            setSelectedIds([]);
            fetchData();
        })
        .catch(err => toast.error("Failed to approve!"));
    };

    return (
        <>
            <ToastContainer />
            <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
                            {/* Left side: Title + Select All */}
                            <div className="d-flex align-items-center">
                                <h3 className="card-title mb-0" style={{ color: '#e96827', marginRight: '15px' }}>
                                    Overtime List
                                </h3>
                                {/* <button className="btn btn-info" onClick={toggleSelectAll}>
                                    {isAllSelected ? "Unselect All" : "Select All"}
                                </button> */}
                            </div>

                            {/* Right side: Entries selector + Search */}
                            <div className="d-flex align-items-center mt-2 mt-md-0" style={{ marginLeft: 'auto' }}>
                                <EntriesSelector
                                    setEntriesPerPage={setEntriesPerPage}
                                    setCurrentPage={setCurrentPage}
                                />
                                <div style={{ position: "relative", width: "250px" }}>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Search"
                                        value={searchTerm}
                                        onChange={e => { handleSearch(e); setCurrentPage(1); }}
                                    />
                                    {searchTerm.length > 0 && (
                                        <span onClick={clearInput} style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer", color: "#aaa", fontSize: "18px" }}>✖</span>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="card-body table-responsive">
                            <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                                <thead>
                                    <tr>
                                        <th>                         <input
                type="checkbox"
                
                checked={isAllSelected}
                onChange={toggleSelectAll}
                style={{ cursor: 'pointer' }}
            />
                </th>
                               
                                        <th>Action</th>
                                        <th>Employee Id</th>
                                        <th>Employee</th>
                                        <th>Department</th>
                                        <th>Overtime Hours</th>
                                        <th>Applied On</th>
                                        <th>Reason</th>
                                        <th>Incharge</th>
                                        <th>Hod</th>
                                        <th>HR</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map((row, index) => (
                                        <tr key={index}>
                                            <td>
                                                {row.floor_status === 2 && row.dept_status === 1 && (
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedIds.includes(row.overtime_id)}
                                                        onChange={(e) => handleCheckboxChange(e, row.overtime_id)}
                                                    />
                                                )}
                                            </td>
                                            <td>
                                                {row.floor_status === 2 && row.dept_status === 1 && (
                                                    <Link to={`/deptotdetails?id=${row.overtime_id}`} title="View Details">
                                                        <i className="fe fe-maximize" />
                                                    </Link>
                                                )}
                                            </td>
                                            <td>{row.employee_id}</td>
                                            <td>{row.employee_name}</td>
                                            <td>{row.department_name}</td>
                                            <td>{row.overtime_hour}</td>
                                            <td>{row.applied_on}</td>
                                            <td>{row.reason}</td>
                                            <td>{ReactHtmlParser(row.incharge_status)}</td>
                                            <td>{ReactHtmlParser(row.hod_status)}</td>
                                            <td>{ReactHtmlParser(row.hr_status)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <button className="btn btn-warning mt-3" onClick={approveSelected}>
                                Approve Selected
                            </button>

                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={setCurrentPage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    fixNavbar: state.settings.isFixNavbar
});

const mapDispatchToProps = (dispatch) => ({
    statisticsAction: (e) => dispatch(statisticsAction(e)),
    statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
});

export default connect(mapStateToProps, mapDispatchToProps)(Dept_ot);
